import * as React from "react";
import styled, { css } from "styled-components";

const StyledPanel = styled.div`
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.secondary};
`;

const StyledPanelHeader = styled.div<IPanelHeaderProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[2]};
  border-radius: ${({ theme }) => `${theme.radii[1]} ${theme.radii[1]} 0 0`};
  background-color: ${({ theme }) => theme.colors.secondaryTwo};
  color: ${({ theme }) => theme.colors.primary};

  ${(props) =>
    props.variant === "secondary" &&
    css`
      background-color: ${({ theme }) => theme.colors.secondaryTwo};
      color: ${({ theme }) => theme.colors.primary};
      text-transform: uppercase;
    `}
`;

const PanelHeading = styled.h4`
  flex: 1;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes[3]};
  line-height: 20px;
  color: inherit;
  font-family: ${({ theme }) => theme.fonts.base};
`;

const StyledPanelFooter = styled.div`
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[2]}`};
  text-align: center;
`;

interface IPanelHeaderProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  variant?: string;
}

const PanelHeader: React.FC<IPanelHeaderProps> = ({
  children,
  title,
  variant,
}) => (
  <StyledPanelHeader variant={variant}>
    <PanelHeading>{title}</PanelHeading>
    {children}
  </StyledPanelHeader>
);

interface IPanelBodyProps {
  children: React.ReactNode;
}

const PanelBody: React.FC<IPanelBodyProps> = ({ children }) => (
  <div>{children}</div>
);

interface IPanelFooterProps {
  children: React.ReactNode;
}

const PanelFooter: React.FC<IPanelFooterProps> = ({ children }) => (
  <StyledPanelFooter>{children}</StyledPanelFooter>
);

interface IPanelProps {
  children?: React.ReactNode;
}

const Panel = ({ children }: IPanelProps) => {
  return <StyledPanel>{children}</StyledPanel>;
};

Panel.Header = PanelHeader;
Panel.Body = PanelBody;
Panel.Footer = PanelFooter;

export default Panel;
